import React, { useState, useEffect } from "react";

export default function ImageWithZoom({ src = "", alt = "image" }) {
  const [open, setOpen] = useState(false);
  const [validSrc, setValidSrc] = useState("");
  const [loading, setLoading] = useState(true);

  // CLEAN URL
  useEffect(() => {
    if (!src) {
      setValidSrc("");
      setLoading(false);
      return;
    }

    let fixed = src.trim();
    fixed = fixed.replace(/^"|"$/g, ""); // remove quotes
    fixed = fixed.replace(/&amp;/g, "&"); // fix encoded &

    // Remove markdown wrapper ![](url)
    if (fixed.startsWith("![")) {
      fixed = fixed.replace(/!\[.*?\]\(/, "").replace(/\)$/, "");
    }

    setValidSrc(fixed);
    setLoading(true);
  }, [src]);

  // Prevent scrolling when enlarged
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
  }, [open]);

  const handleError = () => {
    setValidSrc("https://via.placeholder.com/400?text=Image+Unavailable");
    setLoading(false);
  };

  const handleLoad = () => {
    setLoading(false);
  };

  // ⭐ CORS-SAFE DOWNLOAD (NO REDIRECT) — iframe trick
  //   const handleDownload = () => {
  //     if (!validSrc) return;

  //     const a = document.createElement("a");
  //     a.href = validSrc;
  //     a.target = "_blank"; // open in new tab
  //     a.download = "image.png"; // triggers Save As
  //     a.click();
  //   };

  const handleDownload = () => {
    if (!validSrc) return;

    const downloadUrl = `${
      process.env.REACT_APP_API_URL
    }/chat/download-image?url=${encodeURIComponent(validSrc)}`;

    // Triggers browser "Save As…" automatically
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.click();
  };

  return (
    <>
      {/* Thumbnail */}
      <div style={{ position: "relative", display: "inline-block" }}>
        {loading && (
          <div
            style={{
              width: 120,
              height: 120,
              borderRadius: 10,
              background: "#f0f0f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#666",
              fontSize: 12,
              border: "1px solid #ddd",
            }}
          >
            Generating Image…
          </div>
        )}

        {validSrc && (
          <img
            src={validSrc}
            alt={alt}
            onError={handleError}
            onLoad={handleLoad}
            className="for-mobile-image"
            style={{
              objectFit: "cover",
              borderRadius: 8,
              cursor: "zoom-in",
              marginTop: 8,
              marginBottom: 8,
              display: loading ? "none" : "block",
            }}
            onClick={() => setOpen(true)}
          />
        )}
      </div>

      {/* Zoom Modal */}
      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(0,0,0,0.7)",
            zIndex: 9999,
            backdropFilter: "blur(4px)",
          }}
        >
          {/* Main Zoomed Image */}
          <img
            src={validSrc}
            alt={alt}
            onError={handleError}
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: 10,
              boxShadow: "0 4px 25px rgba(0,0,0,0.4)",
              cursor: "zoom-out",
            }}
            onClick={(e) => e.stopPropagation()} // don't close modal
          />

          {/* CLOSE BUTTON (top right) */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              setOpen(false);
            }}
            style={{
              position: "absolute",
              top: 20,
              right: 25,
              background: "white",
              border: "1px solid #ccc",
              borderRadius: "50%",
              width: 38,
              height: 38,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              fontSize: 22,
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            }}
          >
            ✕
          </button>

          {/* DOWNLOAD BUTTON */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleDownload();
            }}
            style={{
              position: "absolute",
              bottom: 25,
              right: 40,
              padding: "10px 16px",
              background: "white",
              border: "1px solid #ccc",
              borderRadius: 8,
              cursor: "pointer",
              fontSize: 14,
              fontWeight: 500,
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            }}
          >
            ⬇ Download
          </button>
        </div>
      )}
    </>
  );
}
